import { Table } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

export const NoResultRow = styled.div`
  display: flex;
  height: 64px;
  align-items: center;
  width: 100%;
`;

export const StyledTable = styled(Table)(
  ({ theme: { admanColors, spacers } }) => css`
    border-radius: 16px;
    border-spacing: 0;
    border: 1px solid ${admanColors!.gray.light.bg2[0]};
    box-shadow: 0 2px 12px -8px ${admanColors!.gray.light.fg1[6]};
    padding: ${spacers?.spacer02} ${spacers?.spacer04};

    .sticky {
      position: sticky;
      left: 0;
      padding-left: ${spacers?.spacer02};
      z-index: 1;
      background-color: white;
    }

    th.sticky {
      box-shadow: inset 0 0 ${admanColors!.gray.light.bg0[3]}, inset 0 -1px ${admanColors!.gray.light.bg0[3]};
    }

     {
      position: sticky;
      left: 0;
      z-index: 1;
      background-color: white;
    }

    th:first-child {
      box-shadow: inset 0 0 ${admanColors!.gray.light.bg0[3]}, inset 0 -1px ${admanColors!.gray.light.bg0[3]};
    }

    td {
      height: 56px;
      padding: 0;
    }
  `
);
